module.exports = __webpack_public_path__ + "img/d_san.7805999f.gif";